import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from "@angular/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { SharedModule } from "src/shared/shared.module";
import { IonicModule } from "@ionic/angular";
import { TrackingSettingsPage } from "./tracking-settings";
import { FormsModule } from "@angular/forms";
const routes: Routes = [
    { path: '', loadComponent: () =>
      import('./tracking-settings').then(m => m.TrackingSettingsPage)
    }
  ];
@NgModule({
    declarations: [
      TrackingSettingsPage
    ],
    imports: [
        HttpClientModule,
        SharedModule,
        CommonModule,
        RouterModule,
        FormsModule,
        SharedModule,
        IonicModule,
        RouterModule.forChild(routes)

    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    exports: [
    ]
  })
  export class TrackingSettingsModule { }
  export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  }